// Revealers.js
import React from 'react';
import styled from 'styled-components';
import Loader from './Loader';
import LoopingWords from './LoopingWords';

const RevealersContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 2;
`;

const Revealer = styled.div`
  width: 100%;
  background-color: #EDE9E3;
  display: flex;
  justify-content: center;
  align-items: center;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
`;

const Revealers = ({ showLoader }) => {
  return (
    <RevealersContainer >
      {showLoader && <LoopingWords />}
      <Revealer className="revealer r-1"></Revealer>
      <Revealer className="revealer r-2"></Revealer>
    </RevealersContainer>
  );
};

export default Revealers;